module.exports = __webpack_public_path__ + "img/soca.e0362726.png";